export default {
    WELCOME: "",
    WORK_SPACE: "workspace"
};
